import React from "react";

import ToolsBar from "../../../../components/bases/toolsbar/toolsbar";
import { GlobalContext } from "../../../../utils/globalprovider";
import { getlocalhostDatas } from "../../../../utils/apis";

import { sequencesGetEmotionsList } from "../../../../utils/sequences";

import BlinkButton from "../../../../components/bases/blinkbutton/blinkbutton";
import Button from "../../../../components/bases/button/button";
import DialogInput from "../../../dialogs/input";
import SequenceSummary from "./sequencesummary";
import EmotionList from "./emotionlist";
import SequencePlaces from "./sequenceplaces";
import ThemaList from "./themalist";
import TimeCodeSequence from "./timecodesequence";
import imgnext from "./assets/next.png"
import imgprevious from "./assets/previous.png"

import imglock from "./assets/locks.png"
import imgcallia from "./assets/callia.png"
import imggoto from "./assets/goto.png"

import imgundo from "./assets/undo.png"
import imgundoia from "./assets/undoia.png"

import imgcopy from "./assets/copy.png"

import { directDownloadJson } from "../utils";

import imgia from "./assets/ia.png"
import imghuman from "./assets/human.png"

import imgdisable from "./assets/valid/valid_gray.png"
import imgBlinkOn from "./assets/valid/valid_green.png"
import imgBlinkOff from "./assets/valid/valid_black.png"



import "./sequenceblock.css"


class SequencesBlock extends React.Component
{
    static contextType = GlobalContext;

    constructor (props)
    {
        super(props);

        this.locked = true;

        this.state = {

            asset: null, // asset dans la base de données
            assetdatas: null,// asset datas json

            sequenceText: "",

            currentSequence: -1,
            playerTimeCode: -1, // a voir

            sequencesModified: false,
            oneSequenceModified: false,

            summary1:{title: "50 chrs", maxChar: 50},
            summary2:{title: "100 chrs", maxChar: 100},
            


  
            display: {}, // valeur en cours de saisie
            lastvalues: {}, // ancienne valeurs
            lastvaluesia: {}, // ancienne valeurs ia

            conceptSetCorrected: {},
        
            toolsbar:
                {
                    height: 16,

                    items: [
                        {toggle:true, value: this.locked, img: imglock ,type:"button", disable:false,fr:"Faire suivre...",en:"Lock...", nochangecolor:false, key:{key:"LOCKS", cat:"shortcut"}},
                        {type:"space"},
                        {img: imggoto ,type:"button", disable:true,fr:"Aller à...", en:"Goto...", nochangecolor:false, key:{key:"GOTO", cat:"shortcut"}},
                        {type:"space"},
                        {img: imgprevious ,type:"button", disable:true,fr:"Séquence précédente",en:"Previous sequence", nochangecolor:false, key:{key:"PREVIOUS", cat:"shortcut"}},
                        {img: imgnext ,type:"button", disable:true,fr:"Séquence suivante",en:"Next set sequence", nochangecolor:false, key:{key:"NEXT", cat:"shortcut"}},
                        {type:"bigspace"},
                        {img: imgcallia ,type:"button", disable:true,fr:"I.A.",en:"A.I.", nochangecolor:false, key:{key:"IA", cat:"shortcut"}},
                        {type:"bigspace"},
                        {img: imgundoia ,type:"button", disable:true,fr:"Rappeler les valeurs I.A.",en:"Recal A.I. values", nochangecolor:false, key:{key:"UNDOIA", cat:"shortcut"}},
                        {img: imgundo ,type:"button", disable:true,fr:"Annuler les modifications",en:"Cancel changes", nochangecolor:false, key:{key:"UNDO", cat:"shortcut"}},
                    ],
                },
        }

        this.onClickToolsBar = this.onClickToolsBar.bind(this);
        this.onChangeSummary = this.onChangeSummary.bind(this);
        this.onChangeEmotions = this.onChangeEmotions.bind(this)
        this.onChangeThema = this.onChangeThema.bind(this);
        this.onChangePlaces = this.onChangePlaces.bind(this);
        this.OtherFilesdownloadDone = this.OtherFilesdownloadDone.bind(this)
        this.checkIfChanged = this.checkIfChanged.bind(this);
        this.validSequence = this.validSequence.bind(this);
            
        
    }
    setSequencesModified()
    {
        this.setState ({sequencesModified:true})
    }
    getSequencesModified()
    {
      return this.state.sequencesModified;
    }


    clearSequencesModified()
    {
        if (!this.state.oneSequenceModified)
            this.setState ({sequencesModified:false})
    }

    componentDidMount()
    {
        
        directDownloadJson (getlocalhostDatas() + "fr/topics_fr.json",this.OtherFilesdownloadDone,"ipc") 
    }

    componentDidUpdate(prevProps)
    {
        if (prevProps.assetSequences.asid != this.props.assetSequences.asid)
        {
            this.startFirstSequence();
        }
        else
        {
            if (this.props.sequences.sequences !== prevProps.sequences.sequences)
                this.startWithSequence(this.state.currentSequence, false)
        }
    }

    updateToggleValueInToolBar(key,value)
    {
      var ttips = this.state.toolsbar;
      ttips.items.forEach((item, index) => 
      {
                
                if ((item.type !== "space") && (item.type !== "bigspace") && (item.key.key === key))  item.value = value;
            
      });
      this.setState ({toolsbar: ttips});
    }

    setDisabledInToolBar(key, disable, toolsbar)
    {
      toolsbar.items.forEach((item, index) => 
      {
            if ((item.type !== "space") && (item.type !== "bigspace") && (item.key.key === key))  item.disable = disable;
            
      });
      return toolsbar;
    }

    undoFromIA()
    {

        var sequence = JSON.parse(JSON.stringify(this.props.sequences.sequences[this.state.currentSequence]));

        sequence.current.emotions = JSON.parse(JSON.stringify(this.state.lastvaluesia.emotions));
        sequence.current.descriptionA = this.state.lastvaluesia.descriptionA.trim();
        sequence.current.descriptionB = this.state.lastvaluesia.descriptionB.trim();
        sequence.current.sourceA = this.state.lastvaluesia.sourceA;
        sequence.current.sourceB = this.state.lastvaluesia.sourceB;

        sequence.current.thematics = [];
        this.state.lastvaluesia.thematics.forEach (thema =>{
            if (thema.iptccode.trim() !== "")
                sequence.current.thematics.push(thema);
            }

        )
        
        if (this.props.onChange)
            this.props.onChange(sequence, this.state.currentSequence)

        var toolsbar = this.state.toolsbar;
        toolsbar = this.setDisabledInToolBar("LOCKS", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("GOTO", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("PREVIOUS", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("NEXT", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("UNDO", true,toolsbar);
        this.setState({
            sequencesModified: true,
            oneSequenceModified: false,
            toolsbar: toolsbar
        })

    }


    validSequence()
    {

        var sequence = JSON.parse(JSON.stringify(this.props.sequences.sequences[this.state.currentSequence]));
        const display = this.state.display;
        sequence.title = display.title.trim();
        sequence.fictional_epoch = display.fictional_epoch.trim();
        sequence.fictional_place = display.fictional_place.trim();
        sequence.real_epoch = display.real_epoch.trim();
        sequence.real_place = display.real_place.trim();

        sequence.current.emotions = JSON.parse(JSON.stringify(display.fromia.emotions));
        sequence.current.descriptionA = display.fromia.descriptionA.trim();
        sequence.current.descriptionB = display.fromia.descriptionB.trim();
        sequence.current.sourceA = display.fromia.sourceA;
        sequence.current.sourceB = display.fromia.sourceB;

        sequence.current.thematics = [];
        display.fromia.thematics.forEach (thema =>{
            if (thema.iptccode.trim() !== "")
                sequence.current.thematics.push(thema);
            }

        )
        
        if (this.props.onChange)
            this.props.onChange(sequence, this.state.currentSequence)

        var toolsbar = this.state.toolsbar;
        toolsbar = this.setDisabledInToolBar("LOCKS", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("GOTO", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("PREVIOUS", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("NEXT", false,toolsbar);
        toolsbar = this.setDisabledInToolBar("UNDO", true,toolsbar);
        this.setState({
            sequencesModified: true,
            oneSequenceModified: false,
            toolsbar: toolsbar
        })

    }

    getOneSequenceModified()
    {
        return this.state.oneSequenceModified;
    }

    gotoSequence (sequenceNumber, movevideo = true)
    {
        if (!this.state.oneSequenceModified)
        {
            this.startWithSequence(sequenceNumber, movevideo);
            return true;
        }
        return false;
    }
    startWithSequence (sequenceNumber, movevideo = true)
    {
        var currentSequence= -1;
        if ((this.props.assetSequences.asid > 0) || (this.props.sequences.sequences.length > 0))
            currentSequence = sequenceNumber;

        if ((currentSequence <0) || (currentSequence > (this.props.sequences.sequences.length - 1)))
            currentSequence = -1;

        if (currentSequence === -1)
            this.setState ({currentSequence: currentSequence});
        else
        {
            const sequence = JSON.parse(JSON.stringify(this.props.sequences.sequences[currentSequence]));

            



            const display = {
                title: sequence.title,
                real_place: sequence.real_place,
                fictional_place: sequence.fictional_place,
                real_epoch: sequence.real_epoch,
                fictional_epoch: sequence.fictional_epoch,

                fromia:{
                    emotions: sequence.current.emotions,
                    thematics: sequence.current.thematics,
                    descriptionA: sequence.current.descriptionA,
                    descriptionB: sequence.current.descriptionB,
                    sourceA: sequence.current.sourceA,
                    sourceB: sequence.current.sourceB,
                }
            };

            const lastvalues = JSON.parse(JSON.stringify(display));

            const lastvaluesia = {
               
                emotions: sequence.ia.emotions,
                thematics: sequence.ia.thematics,
                descriptionA: sequence.ia.descriptionA,
                descriptionB: sequence.ia.descriptionB,
                sourceA: sequence.ia.sourceA,
                sourceB: sequence.ia.sourceB,
            };


            var text="";
            if (this.props.onGetText)
                text = this.props.onGetText(sequence.in,sequence.out,currentSequence);

            const ret = this.setToolsBarsMode(display, lastvalues, lastvaluesia);
            this.setState ({
                currentSequence: currentSequence,
                display: ret.display,
                lastvalues: lastvalues,
                lastvaluesia: lastvaluesia,
                oneSequenceModified: ret.modified,
                modifiedia: ret.modifiedia,
                sequenceText: text,
                toolsbar: ret.toolsbar,
                in: sequence.in,
                out:sequence.out,
            })

            if ((this.locked) && (movevideo))
            {
                const timecode = sequence.in;
                if (this.props.onMove) this.props.onMove(timecode);
            }

        }

    }   

    sameIptcCodes(var1, var2) {
        const codes1 = var1
            .map(item => item.iptccode)
            .filter(code => code && code.trim() !== "");

        const codes2 = var2
            .map(item => item.iptccode)
            .filter(code => code && code.trim() !== "");

        if (codes1.length !== codes2.length) {
            return false;
        }

        const set1 = new Set(codes1);
        const set2 = new Set(codes2);

        if (set1.size !== set2.size) {
            return false;
        }

        return [...set1].every(code => set2.has(code));
    }
    

    setToolsBarsMode(display, lastvalues, lastia)
    {
            var toolsbar = this.state.toolsbar;
            
            var modified = false;

            // valeur not ia

            if (display.title.trim() !== lastvalues.title.trim()) modified = true;
            if (display.real_place.trim() !== lastvalues.real_place.trim()) modified = true;
            if (display.real_epoch.trim() !== lastvalues.real_epoch.trim()) modified = true;
            if (display.fictional_place.trim() !== lastvalues.fictional_place.trim()) modified = true;
            if (display.fictional_epoch.trim() !== lastvalues.fictional_epoch.trim()) modified = true;



            // valeur ia
            if (display.fromia.descriptionA.trim() !== lastvalues.fromia.descriptionA.trim()) modified = true;
            if (display.fromia.descriptionB.trim() !== lastvalues.fromia.descriptionB.trim()) modified = true;

            // les emotions
            const nblastemotions = lastvalues.fromia.emotions.length;
            if (nblastemotions !== display.fromia.emotions.length) 
                modified = true;
            else
            {
                for (var i=0; i< nblastemotions; i++)
                {
                    if (
                        (lastvalues.fromia.emotions[i].type != display.fromia.emotions[i].type) ||
                        (lastvalues.fromia.emotions[i].intensity != display.fromia.emotions[i].intensity) ||
                        (lastvalues.fromia.emotions[i].sentiment != display.fromia.emotions[i].sentiment)
                    )
                    modified = true;
                }
            }

            // mes thematiques


            
            var themamodified = !this.sameIptcCodes (display.fromia.thematics, lastvalues.fromia.thematics);

            if (themamodified) modified = true;

            toolsbar = this.setDisabledInToolBar("LOCKS", modified,toolsbar);
            toolsbar = this.setDisabledInToolBar("GOTO", modified,toolsbar);
            toolsbar = this.setDisabledInToolBar("PREVIOUS", modified,toolsbar);
            toolsbar = this.setDisabledInToolBar("NEXT", modified,toolsbar);
            toolsbar = this.setDisabledInToolBar("UNDO", !modified,toolsbar);





            var modifiedia = false;
            if (display.fromia.descriptionA.trim() !== lastia.descriptionA.trim()) 
            {
                display.fromia.sourceA = "HUMAN";
                
                modifiedia = true;
            }
            else
                display.fromia.sourceA = "IA";

            if (display.fromia.descriptionB.trim() !== lastia.descriptionB.trim()) 
            {
                
                display.fromia.sourceB = "HUMAN";
                modifiedia = true;
            }
            else
                display.fromia.sourceB = "IA";


            display.fromia.emotions.forEach(emotion =>
            {
                const type = emotion.type;
                const sentiment = emotion.sentiment;
                const intensity = emotion.intensity;

                var found = false;
                var confidence = 1;
                lastia.emotions.forEach (iamotion =>{
                    if (
                        (iamotion.type === type) &&
                        (iamotion.sentiment === sentiment) &&
                        (iamotion.intensity === intensity)
                    )
                    {
                        found = true;
                        confidence = iamotion.confidence;
                    }
                    
                });
                if (!found)
                {
                    emotion.source = "HUMAN";
                    emotion.confidence = 1;
                    modifiedia = true;
                }
                else
                {
                    emotion.source = "IA";
                    emotion.confidence = confidence;
                }
            });

            var themamodifiedia = !this.sameIptcCodes (display.fromia.thematics, lastia.thematics);
            if (themamodifiedia) modifiedia = true;


            
            display.fromia.thematics.forEach(thema =>
            {
                const iptccode = thema.iptccode;
                var found = false;
                var confidence = 1;
                lastia.thematics.forEach (iathema =>{
                    
                    if (iathema.iptccode === iptccode) 
                    {
                        
                        found = true;
                        confidence = iathema.confidence;
                    }
                    
                });
                if (!found)
                {
                    thema.source = "HUMAN";
                    thema.confidence = 1;
                }
                else
                {
                    thema.source = "IA";
                    thema.confidence = confidence;
                }

            });


            toolsbar = this.setDisabledInToolBar("UNDOIA", !modifiedia,toolsbar);

            return {
                    toolsbar:toolsbar,
                    modified: modified,
                    modifiedia: modifiedia,
                    display: display,
                }


            /*
            const display = {
                title: sequence.title,
                real_place: sequence.real_place,
                fictional_place: sequence.fictional_place,
                real_epoch: sequence.real_epoch,
                fictional_epoch: sequence.fictional_epoch,

                fromia:{
                    emotions: sequence.current.emotions,
                    thematics: sequence.current.thematics,
                    descriptionA: sequence.current.descriptionA,
                    descriptionB: sequence.current.descriptionB,
                    sourceA: sequence.current.sourceA,
                    sourceB: sequence.current.sourceB,
                }
            };
            */





            
    }


    startFirstSequence()
    {
        this.startWithSequence(0, false);
    }


    OtherFilesdownloadDone(blob, infos, file)
    {
        var conceptSetCorrected = blob;
        // on nettoie si besoin
        Object.values(conceptSetCorrected).forEach (elem =>{
        if ("iptc_code" in elem)
            elem.iptc_code = elem.iptc_code.replace(/^medtop:/, "");
        if ("children" in elem)
        {
            elem.children.forEach(child =>{
                if (("iptc_code" in child) && (child.iptc_code))
                child.iptc_code = child.iptc_code.replace(/^medtop:/, "");

            })
        }
        })

        

        this.setState({conceptSetCorrected:conceptSetCorrected});
        this.startFirstSequence();
        
    }

    //  ***********************************************************************************************************************
    //  * test si il y des modifications
    //  ***********************************************************************************************************************
    checkIfChanged(display)
    {
        var lastvalues = this.state.lastvalues;

        const ret = this.setToolsBarsMode(display, lastvalues, this.state.lastvaluesia);
        this.setState ({
            display: ret.display,
            oneSequenceModified: ret.modified,
            modifiedia: ret.modifiedia,
            toolsbar: ret.toolsbar,
        })

    }

    //  ***********************************************************************************************************************
    //  * gestion toolsbar
    //  ***********************************************************************************************************************
    onClickToolsBar(datas)
    {
        switch (datas.cat)
        {
            case "shortcut":
                switch (datas.key)
                {

                    case "PREVIOUS":
                        if (this.state.currentSequence !== 0)
                            this.startWithSequence(this.state.currentSequence-1);
                        break;

                    case "NEXT":
                        if (this.state.currentSequence < (this.props.sequences.sequences.length-1))
                            this.startWithSequence(this.state.currentSequence+1);
                        break;
                    case "LOCKS":
                        
                        this.locked = !this.locked;
                        this.updateToggleValueInToolBar(datas.key,this.locked);

                        if ((this.locked) && (this.state.currentSequence !== -1))
                        {
                            var tcin = this.props.sequences.sequences[this.state.currentSequence].in;
                            if (this.props.onMove) this.props.onMove(tcin);
                        }
                        break;
                    case "GOTO":
                        if (this.props.onGetTimeCode)
                        {
                            const tc = this.props.onGetTimeCode();
                            var newsequence = -1;
                            this.props.sequences.sequences.forEach( (sequence,index)=>
                            {
                                if ((sequence.in <= tc) && (sequence.out >=tc))
                                    newsequence = index;
                            })
                            if (newsequence !== -1) this.startWithSequence(newsequence);
                        }
                        break;
                    case "UNDO":
                        this.startWithSequence(this.state.currentSequence);
                        break;
                    case "UNDOIA":
                        this.undoFromIA();
                        break;

                }
        }
    }
    //  ***********************************************************************************************************************
    setTimeCode (timecode, force = false)
    {
        
    }



    onChangeEmotions(datas)
    {
        
        var display = JSON.parse(JSON.stringify(this.state.display));
        display.fromia.emotions = datas;
        this.checkIfChanged(display)
    }

    onChangePlaces(datas)
    {
        
        var display = JSON.parse(JSON.stringify(this.state.display));
        display.real_epoch = datas.real_epoch;
        display.real_place = datas.real_place;
        display.fictional_epoch = datas.fictional_epoch;
        display.fictional_place = datas.fictional_place;
        this.checkIfChanged(display)

    }

    onChangeThema(datas)
    {
        
        var display = JSON.parse(JSON.stringify(this.state.display));
        display.fromia.thematics = datas;
        this.checkIfChanged(display)
    }

    onChangeSummary(datas)
    {
        

        var display = JSON.parse(JSON.stringify(this.state.display));
        display.fromia.descriptionA = datas.A.text
        display.fromia.descriptionB = datas.B.text

        this.checkIfChanged(display)

    }


    render()
    {
        if (this.state.currentSequence === -1)
            return (<></>)
        else
        {
            const emotionstype = sequencesGetEmotionsList(this.context.language);
            var titlenumber = this.context.language=="fr"?"Séquence n° ":"Sequence #"

            
            return (
                <div 
                    style = {{
                        width:"100%",
                        height: "calc(100% - 3px)",
                        marginBottom:"3px",
                    }}>

                    <div style={{position:"absolute", top:"25px", right:"15px" }}>
                    <BlinkButton
                        
                        disable={!this.state.oneSequenceModified}
                        imgDisabled={imgdisable}
                        imgBlinkOn={imgBlinkOn}
                        imgBlinkOff={imgBlinkOff}
                        interval={500}
                        onClick={this.validSequence}
                        width={20}
                        height={20}
                    />
                    </div>
                    <ToolsBar onClick={this.onClickToolsBar} toolsbar={this.state.toolsbar}/>
                    <div className = "sequenceblock-noscrollbar" 
                    style = {{
                        width:"100%",
                        height: "calc(100% - 23px)",
                        overflowX: "hidden",
                        overflowY: "scroll",
                        scrollbarWidth: "none",
                        msOverflowStyle: "none"                        
                    }}>

                    
                    <div style={{width:"100%", fontSize:"15px"}}><span style={{color:"#808080"}}>{titlenumber}</span>{this.state.currentSequence + 1}</div>
                    
                    <TimeCodeSequence
                        timecodeasset = {this.props.timecodeasset}
                        timecode = {this.props.timecode}
                        onMove = {this.props.onMove}
                        in = {this.state.in}
                        out = {this.state.out}
                    />
                    
                    <DialogInput
                    value = {this.state.display.title}
                    disabled={false}
                    autoFocus = {false}
                    readOnly = {false}
                    width = "calc(100% - 20px)"
                    onChangeValue = { e=> {
                        
                        
                        var display = JSON.parse(JSON.stringify(this.state.display));
                        display.title = e;
                        this.checkIfChanged(display);

                    }
                    }
                    title = {this.context.language=="fr"?"Titre séquence":"Sequence Title"}
                    />
                
                    <div 
                        style = {{
                            width:"96%",
                            marginLeft: "2%",
                            marginTop:"18px",

                        }}>



                        <SequenceSummary
                            valuesA={{
                                text: this.state.display.fromia.descriptionA,
                                img: this.state.display.fromia.sourceA == "IA"?imgia:imghuman,
                                title: this.state.summary1.title,
                                maxChar: this.state.summary1.maxChar
                            }}

                            valuesB={{
                                text: this.state.display.fromia.descriptionB,
                                img: this.state.display.fromia.sourceB == "IA"?imgia:imghuman,
                                title: this.state.summary2.title,
                                maxChar: this.state.summary2.maxChar
                            }}

                            onChange={this.onChangeSummary}
                        />

                    </div>

                    <div 
                        style = {{
                            width:"96%",
                            marginLeft: "2%",
                            marginTop:"10px",
                        }}>


                        <EmotionList
                            emotionsList={emotionstype}

                            list={this.state.display.fromia.emotions}

                            imgIA={imgia}
                            imgHuman={imghuman}

                            maxLines={3}

                            onChange={this.onChangeEmotions}

                            defaultEmotion={0}
                            defaultSource="HUMAN"
                            defaultConfidence={1}
                            defaultIntensity={1}
                            defaultSentiment={0.5}

                            sentimentLimit={{
                                min: -0.5,
                                max: 0.5
                            }}

                            intensityLimit={{
                                min: 0.1,
                                max: 1.0
                            }}
                        />
                    </div>
                    <div 
                        style = {{
                            width:"96%",
                            marginLeft: "2%",
                            marginTop:"10px",
                        }}>
                    

                        <ThemaList
                            conceptSet={this.state.conceptSetCorrected}

                            list={this.state.display.fromia.thematics}

                            imgIA={imgia}
                            imgHuman={imghuman}

                            maxLines={3}

                            defaultImg="HUMAN"
                            defaultConfidence={1}

                            onChange={this.onChangeThema}
                        />
                    </div>
                    <div 
                        style = {{
                            width:"96%",
                            marginLeft: "2%",
                            marginTop:"10px",
                        }}>

                        <SequencePlaces
                            real_place= {this.state.display.real_place}
                            fictional_place= {this.state.display.fictional_place}
                            real_epoch= {this.state.display.real_epoch}
                            fictional_epoch= {this.state.display.fictional_epoch}
                            onChange={this.onChangePlaces}
                        />
                    </div>
                    <Button tooltip={{fr:"Copier le texte",en:"Copy text"}} 
                        image={imgcopy} 
                        width={20} height={20} 
                        
                        onClick={e=>{
                                const div = document.getElementById("divSeqText");
                                if (div)
                                    navigator.clipboard.writeText(div.innerText);
                             
                            }}                            
                        />
                    <div className="sequenceblockText" id="divSeqText"  style={{marginTop:"-2px"}}>
                        
                        {this.state.sequenceText}
                    </div>


                </div>

                </div>
            )
        }

    }
}
SequencesBlock.defaultProps = 
{
    sequences: {sequences:[]},
    assetSequences:{asid:0, astitle:""}


};

export default SequencesBlock;
